module.exports = ".line-height {\n    line-height: 2;\n}\n\n.submit-btn {\n    margin: 20px 0 0 0 ;\n}"